/**
 * 生成UUID
 * @returns {string}
 */
export const uuid = () => {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('')
  return uuid
}

/**
 * 复制内容
 * */
export function tCopyContent (str) {
  if (!str) {
    return this.$message.success('No content is copied')
  }
  this.$copyText(str)
    .then(e => {
      this.$message.success('Copy success')
    }, function (e) {
      this.$message.fail('Copy failed, please copy manually！')
    }
      )
}

// utils.js

export function buildDataList (items, parentId) {
  const result = []

  for (const item of items) {
    if (item.pid === parentId) {
      const option = {
        value: item.id,
        label: item.title
      }
      const newItem = {...option}
      const children = buildDataList(items, item.id)
      if (children.length > 0) {
        newItem.children = children
      }
      result.push(newItem)
    }
  }
  return result
}

// utils.js

export function buildArrList (items, parentId) {
  const result = []

  for (const item of items) {
    if (item.pid === parentId) {
      const newItem = {...item}
      const children = buildArrList(items, item.id)
      if (children.length > 0) {
        newItem.children = children
      }
      result.push(newItem)
    }
  }

  return result
}

export function findOptionPath (options, itemId, path = []) {
  let selectId = parseInt(itemId)
  for (const option of options) {
    const currentPath = [...path, option.value]
    if (option.value === selectId) {
      return currentPath // 返回完整的选项路径
    }
    if (option.children) {
      const childPath = findOptionPath(option.children, selectId, currentPath)
      if (childPath) {
        return childPath // 如果在子级中找到了选项，则返回子级的路径
      }
    }
  }
  return null // 如果找不到选项，则返回 null 或其他适当的值
}

// scrollUtils.js

export function scrollToTop (duration = 800) {
  const startY = window.scrollY
  const distance = 0 - startY
  let startTime = null

  function animate (currentTime) {
    if (!startTime) {
      startTime = currentTime
    }

    const progress = currentTime - startTime
    const easeInOutCubic = t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    const scrollPosition = easeInOutCubic(progress / duration) * distance + startY

    window.scrollTo(0, scrollPosition)

    if (progress < duration) {
      requestAnimationFrame(animate)
    }
  }

  requestAnimationFrame(animate)
}

/**
 * 获取运行环境
 * @returns {string}
 */
export function getProcess () {
  return process.env.NODE_ENV === 'production' ? 'https://fulfillment.printbelle.com/prod_api' : 'http://192.168.50.148:8112'
}

/**
 * 根据id筛选出对应名称
 * @param list
 * @param targetId
 * @returns {null|*}
 */
export function getIdByName (list, targetId) {
  const foundItem = list.find(item => parseInt(item.id) === parseInt(targetId))
  return foundItem ? foundItem.name : 'Product'
}

/**
 * 组装数据
 * @param originalData
 * @returns {{name: string, itemList: *}[]}
 */
export function setDataToSpecs (originalData) {
  const specsMap = {}

  for (const item of originalData) {
    for (const property of item.list) {
      const name = property.propertyName
      const value = property.propertyValue
      if (!specsMap[name]) {
        specsMap[name] = []
      }
      if (!specsMap[name].includes(value)) {
        specsMap[name].push(value)
      }
    }
  }

  const specs = Object.keys(specsMap).map(name => ({
    name,
    item: specsMap[name].map(value => ({name: value}))
  }))

  return specs
}

/**
 * 根据id匹配选中数据
 * @param data
 * @param defaultProductId
 * @returns {[]|*[]}
 */
export function getVariantDataById (data, defaultProductId) {
  for (const item of data) {
    if (parseInt(item.id) === parseInt(defaultProductId)) {
      return item
    }
  }
  return []
}

/**
 * 组装数据
 * @param productVO
 * @returns {{difference: *, id: *}[]}
 */
export function setDifferenceArray (productVO) {
  return productVO.flatMap(item =>
    item.variantVOS.flatMap(variant => {
      const properties = variant.list.map(prop => `${prop.propertyValue}`)
      return {
        id: variant.id,
        difference: properties.join(',')
      }
    })
    )
}

/**
 * 判断对象和id是否为空
 * @param obj
 * @returns {boolean}
 */
export function isIdEmpty (obj) {
  return !obj || !obj.id // Return true if object is null, undefined, or id is empty
}



// WEBPACK FOOTER //
// ./src/utils/utils.js